import './products.scss';
import { useParams } from 'react-router-dom';
import { data } from '../../data-en';
import useGaTracker from '../../hooks/useGaTracker';
import usePageTitle from '../../hooks/usePageTitle';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function Products() {
    useGaTracker();
    usePageTitle('Products');

    const params = useParams();
    let category;
    let categoryId = params.category;

    let products;
    if (categoryId) {
        category = data.categories.find((category) => category.id === categoryId);
        products = category ? category.products : [];
    } else {
        products = data.categories.flatMap((category) => category.products);
    }

    return (
        <div className="products">
            <div className='bg__color'>
                <h1>Products</h1>
            </div>
            <div className='wrapper-container'>
                <div className='buttons'>
                    <a className={`button ${categoryId === null ? 'active' : ''}`} href="/products">All</a>
                    {data.categories.map((category) => (
                        <a className={`button ${categoryId === category.id ? 'active' : ''}`} href={`/products/${category.id}`}>
                            {category.title}
                        </a>
                    ))}
                </div>
                {products.map((product) => (
                    <div className='variant-container'>
                        <div className='image'>
                            <LazyLoadImage alt="Product"  src={product.image} />
                        </div>
                        <div className='list'>
                            {product.variants.map((variant) => (
                                <div>
                                    {variant}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Products;
